import { DatasourcePollSyncUpdate } from '@futrli-sdk/organisations';

import { API_PATHS } from '../app-core';
import { APIClients, getAxiosResponseData } from '../api-client';

export const fetchDataSourcePollData = async (queryParams: string): Promise<DatasourcePollSyncUpdate[]> => {
  const path = `${API_PATHS.DATASOURCE_POLL_DATA}?${queryParams}`;
  const response = await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: path
      }
    }
  });
  return getAxiosResponseData(response.data);
};
